import UJS from "@rails/ujs"

import "../MobileNavigation.res.mjs"
import "../blobs"
import "../posts-filter-bar"
import "../table-of-contents"

UJS.start()
